export const environment = {
    api_url : process.env["REACT_APP_API_URL"],
    app_url : process.env["REACT_APP_URL"]
}
